import { createContext } from "react";

/** True when the component tree is hosted inside the validation summary modal. */
export const ValidationModalContext = createContext(false);
